import React from 'react';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { TrainerMembershipDesktop } from './trainer-membership.desktop';
import { TrainerMembershipMobile } from './trainer-membership.mobile';
import { PageProps } from 'gatsby';

export type MembershipTrainerData = {
  first_name: string;
  last_name: string;
  cover_image_url: string;
  profile_pic_url: string;
  _id: string;
  bio: string;
  price: number;
  available_spots: number;
  whatsapp_url: string;
  m_me_url: string;
  paypal_plan_id: string;
};

interface Props extends PageProps {
  pageContext: {
    trainer: MembershipTrainerData;
  };
}

const TrainerMembershipTemplate: React.FC<Props> = ({
  pageContext: { trainer },
  location
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const content = isDesktop ? (
    <TrainerMembershipDesktop trainerData={trainer} />
  ) : (
    <TrainerMembershipMobile trainerData={trainer} />
  );

  return (
    <Layout hideBackLinking>
      <SEO
        location={location}
        keywords={[
          `membership`,
          `personal trainer`,
          `fitness coach`,
          `${trainer.first_name} ${trainer.last_name}`,
        ]}
        title={`${trainer.first_name} - Membership`}
        description={`Start membership with ${trainer.first_name} - ${trainer.bio}`}
        image={trainer.profile_pic_url}
      />
      {content}
    </Layout>
  );
};

export default TrainerMembershipTemplate;
